import { Gift } from "lucide-react";

/**
 * "🎁 Free Trial: ₹1/Patient Active (X days remaining)" — surfaces the
 * hospital's 30-day intro-pricing period on both the Hospital Admin
 * dashboard and the SuperAdmin management panel. Renders NOTHING when
 * `trial` is null / expired, so it silently no-ops for standard-plan
 * hospitals.
 *
 * Backend contract (from `payout_engine.trial_status`):
 *   { active: bool, days_remaining: int, started_at, expires_at }
 */
export default function TrialBadge({ trial, className = "" }) {
  if (!trial || !trial.active) return null;
  const d = trial.days_remaining ?? 0;
  return (
    <span
      data-testid="trial-active-badge"
      className={
        "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-semibold " +
        "bg-gradient-to-r from-emerald-100 to-teal-100 text-emerald-800 " +
        "border border-emerald-300 shadow-sm select-none " +
        className
      }
      title={`Trial ends on ${trial.expires_at ? new Date(trial.expires_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "-"}`}
    >
      <Gift className="w-4 h-4" strokeWidth={2.4} />
      <span>Free Trial: ₹1/Patient Active</span>
      <span className="ml-1 px-1.5 py-0.5 rounded-md bg-white/70 text-emerald-700 text-xs font-mono tabular-nums">
        {d} day{d === 1 ? "" : "s"} left
      </span>
    </span>
  );
}
